export default "__VITE_ASSET__C5m53dqf__"